// extracted by mini-css-extract-plugin
module.exports = {"link":"genericLink_link__Mn0Kc","wrapper":"genericLink_wrapper__7Ab1N"};